import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BattleFrame from '../components/frame/BattleFrame'
import BattleStage from '../components/stage/BattleStage'
import InteractiveActionBar from '../components/ui/atf/InteractiveActionBar'
import BattleLog from '../components/ui/chat/BattleLog'
import StoryMode from '../components/ui/other/StoryMode'
import TurnCounter from '../components/ui/atf/TurnCounter'
import getFactions from '../redux/selectors/getFactions'
import getBattleData from '../redux/selectors/getBattleData'
import getNextActors from '../redux/selectors/getNextActors'
import { initBattle, resetBattle } from '../redux/actions/game/battle.actions'
import { selectTargetActor } from '../redux/actions/game/targetActor.actions'
import STAGES from '../constants/STAGES'
import getSquadWithEquipment from '../redux/selectors/getSquadWithEquipment'

const Battle = (props) => {
    const {
        squadUnits,
        battle,
        battleStage,
        factions,
        selectedActor,
        nextActors,
        battleLog,
        initialiseStage,
        clearStage,
        selectActor,
    } = props

    const stageData = STAGES[battleStage]
    const { currentBanner: stageTitle } = battle

    const [stageHeaderClass, setStageHeaderClass] = useState('battleStage__header')

    useEffect(() => {
        initialiseStage(squadUnits, stageData)
        return () => {
            clearStage()
        }
    }, [initialiseStage, clearStage, squadUnits, stageData])

    useEffect(() => {
        if (stageTitle && stageTitle !== 'loading') {
            setStageHeaderClass('battleStage__header battleStage__header--animating')
            setTimeout(
                () => {
                    setStageHeaderClass('battleStage__header battleStage__header--animated')
                },
                2500
            )
        }
    }, [stageTitle])

    return (
        <BattleFrame>
            <div className="scene--base scene__battleStage">
                <div className="battleStage__stage">
                    <div className={stageHeaderClass}>
                        <div className="battleStage__header--title">
                            {stageTitle}
                        </div>
                    </div>
                    <BattleStage
                        factions={factions}
                        selectedActor={selectedActor}
                        unitClickHandler={selectActor}
                    />
                </div>
                <div className="battleStage__iab">
                    <TurnCounter />
                    <InteractiveActionBar
                        nextActors={nextActors}
                        selectedActor={selectedActor}
                    />
                </div>
                <div className="battleStage__ui">
                    <BattleLog eventLog={battleLog} />
                </div>
                <StoryMode />
            </div>
        </BattleFrame>
    )
}

Battle.propTypes = {
    factions: PropTypes.object.isRequired,
    selectedActor: PropTypes.string.isRequired,
    nextActors: PropTypes.array.isRequired,
    battleLog: PropTypes.array.isRequired,
    squadUnits: PropTypes.array.isRequired,
    battle: PropTypes.object.isRequired,
    battleStage: PropTypes.string.isRequired,
    initialiseStage: PropTypes.func.isRequired,
    clearStage: PropTypes.func.isRequired,
    selectActor: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    factions: getFactions(state),
    nextActors: getNextActors(state),
    battleLog: state.battleLog,
    squadUnits: getSquadWithEquipment(state),
    battle: getBattleData(state),
    battleStage: state.battleStage,
    selectedActor: state.targetActor,
})

const mapDispatchToProps = dispatch => ({
    initialiseStage: (squadUnits, stage) => {
        dispatch(initBattle(squadUnits, stage))
    },
    clearStage: () => dispatch(resetBattle()),
    selectActor: actor => dispatch(selectTargetActor(actor)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Battle)
